import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as _ser from "../../../_redux/_services/ProjectsSlice";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import ProjectsCreate from "../ProjectsCreate/ProjectsCreate";
import "./projects_table.css";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";

const initalState = { data: null, message: "", isloader: true };

const ProjectsTable = () => {
  const [projectsData, setProjectsData] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);

  const dispatch = useDispatch();
  const [config, setConfig] = useState(
    JSON.parse(JSON.stringify(configuration)),
  );
  const [filterValue, setFilterValue] = useState("");

  const payLoad = {
    offset: config.currentPage,
    limit: config.limitData,
    keyword: "",
    isActive: null,
  };

  useEffect(() => {
    getProjects(payLoad);
  }, []);

  const projects = useSelector((state) => state.GetProjects.data);

  const getProjects = async (payLoad) => {
    setProjectsData([]);
    dispatch(_ser.getProjectsAsync(payLoad));
  };

  useEffect(() => {
    if (projects && projects?.rows?.length > 0) {
      setProjectsData([]);
      let projectData = JSON.parse(JSON.stringify(projects));
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = projectData.total_count;
      configure.totalRecordsCount = projectData.total_count;
      configure.totalRecordsCountText = "Total Projects";
      setConfig(configure);
      setProjectsData(projectData.rows);
      dispatch(_ser.getProjectsStartReducer(initalState));
    } else if (projects) {
      setConfig(configuration);
      setProjectsData([]);
    }
  }, [projects]);

  // for dynamic component received props
  const onReceiveActionHandler = async (type, obj) => {
    if (type === "pageRange") {
      setConfig({
        ...config,
        limitData: obj,
        recordperPage: obj,
        currentPage: 1,
      });
      const payload = { limit: obj, offset: 1, keyword: filterValue || "" };
      getProjects(payload);
    } else if (type === "pagination") {
      const payload = {
        limit: obj.limit,
        offset: obj.offset,
        keyword: filterValue || "",
      };
      getProjects(payload);
      let configure = JSON.parse(JSON.stringify(config));
      configure.currentPage = obj.current;
      setConfig(configure);
    } else if (type === "searchResult") {
      if (obj.keyword !== "") {
        obj.offset = obj.offset ? obj.offset : 1;
        setFilterValue(obj.keyword);
        const payload = {
          limit: config.limitData,
          offset: obj.offset,
          keyword: obj.keyword,
        };
        getProjects(payload);
      }
    } else if (type === "cancelSearchResult") {
      setFilterValue("");
      getProjects(payLoad);
    } else if (type === "newApplicants") {
      setIsRightSidePannel(true);
    } else if (type === "keyword") {
      setFilterValue(obj);
    }
  };

  const onReceivePropsHandler = (boolean, type) => {
    setIsRightSidePannel(boolean);
  };

  const code = useSelector((state) => state.AddProjects.data);

  useEffect(() => {
    if (code === 200) {
      setIsRightSidePannel(false);
      setConfig(JSON.parse(JSON.stringify(configuration)));
      getProjects(payLoad);
      dispatch(_ser.addProjectsStartReducer(initalState));
    }
  }, [code]);

  return (
    <>
      <div style={{ marginTop: "80px", marginBottom: "35px" }}>
        <div style={{ background: "#fff", padding: "22px 47px 47px" }}>
          <div
            className="addProjectIcon"
            onClick={() => setIsRightSidePannel(true)}
          >
            <DashboardPlusicon width={35} height={36} />
          </div>
          {/* for dynamic Table */}
          <div id="projects-list-table">
            {projectsData && projectsData.length > 0 && (
              <DynamicTable
                key="projects-dynamic-table"
                config={config}
                data={projectsData}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                filterValue={filterValue}
                addModel={{}}
                searchKeyWord="Search by Project Name"
                noDataText="No Projects Found"
                actions={actionsList}
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            )}
            {projectsData && projectsData.length === 0 && (
              <DynamicTable
                key="projects-dynamic-table"
                config={config}
                data={projectsData}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                filterValue={filterValue}
                addModel={{}}
                searchKeyWord="Search by Project Name"
                noDataText="No Projects Found"
                actions={actionsList}
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            )}
          </div>
        </div>
        {isRightSidePannel ? (
          <RightSideBar
            componentData={
              <ProjectsCreate onReceiveProps={onReceivePropsHandler} />
            }
            componentLayout={pannelobj}
            footerImg={""}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : null}
      </div>
    </>
  );
};

export default ProjectsTable;

/// for dynamic Table config Object
const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 20,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: true,
  totalRecordsCount: 0,
  totalRecordsCountText: "Total Projects",
  limitData: 20,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: true,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ["Delete"];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Project Id",
    type: "projects",
    mappingName: "projectCode",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center ",
    width: "350px",
    isEdit: true,
    nagigate: "/ats/layout/projects/view",
    openNewTab: true,
  },
  {
    id: 2,
    displayName: "Project Name",
    type: "projects",
    mappingName: "name",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext  text-center NameCapitalise",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/projects/view",
  },
  {
    id: 3,
    displayName: "Created By",
    type: "projects",
    mappingName: "createdBy",
    theadClass: "dynatableheadtext text-center  ",
    tbodyClass: "dynatablebodytextemail text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/projects/view",
  },
  {
    id: 4,
    displayName: "Date and Time",
    type: "projects",
    mappingName: "createdDate",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/projects/view",
  },
  {
    id: 5,
    displayName: "Project Status",
    type: "projects",
    mappingName: "status",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/projects/view",
  },
];

const pannelobj = {
  title: "Create New Project",
  description: "",
  bgImage: "",
};
